import * as React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Path } from '../../../common/consts/Path';

export interface AppPageComponentBaseRoute {
	path: Path;
}

export interface AppPageComponentRoute extends AppPageComponentBaseRoute {
	Component: React.ComponentType;
}

export interface AppPageRedirectRoute extends AppPageComponentBaseRoute {
	redirect: string;
}

export type AppPageRoute = OneOf<[AppPageComponentRoute, AppPageRedirectRoute]>;

export interface BaseAppPageProps {
	routes: AppPageRoute[];
	loading?: React.SuspenseProps['fallback'];
}

export const BaseAppPage: React.FC<BaseAppPageProps> = function AppPage({ routes, loading }) {
	return (
		<React.Suspense fallback={loading ?? null}>
			<Routes>
				{routes.map(({ path, Component, redirect }) => {
					return <Route element={redirect ? <Navigate replace to={redirect} /> : Component ? <Component /> : null} path={path} key={path} />;
				})}

				{/* todo: add route that redirects to the NotFound page */}
			</Routes>
		</React.Suspense>
	);
};
